import {FormTagManager} from "./formTagManager"


export class FormValidation {
    static init() {
        FormTagManager.init()
        const forms = [...document.querySelectorAll('.form-wrapper form')];
        forms.forEach(form => new FormValidation(form))
    }

    constructor(form) {
        this.executed = false;
        this.valid = false;
        this.validateForm(form);
        this.recaptchaWrapper = form.querySelector('.g-recaptcha__wrapper');
        this.recaptcha = form.querySelector('.g-recaptcha');
        if (this.recaptcha) {
            window[this.recaptcha.dataset.callback] = () =>  this.execute()
            window[this.recaptcha.dataset.expiredCallback] = () =>  this.reset()
        }
    }

    onSubmit(e) {
        if (!this.executed) {
            this.recaptchaWrapper.classList.add('g-recaptcha--error')
            e.preventDefault()
        } else if (!this.valid) {
            e.preventDefault()
        }
    }

    execute() {
        this.executed = true;
        this.recaptchaWrapper.classList.remove('g-recaptcha--error')
    }

    reset() {
        this.executed = false;
    }

    validateForm(form) {
        let allErrors = [];

        // Check on the fly
        form.addEventListener('click', function(event) {
            if (('input, select, textarea').includes(event.target.tagName.toLowerCase()) && event.target.type !== 'submit') {
                ['blur', 'keyup', 'change'].forEach( function(e) {
                    event.target.addEventListener(e, function(){
                        setTimeout(() => {
                            validateFields(event.target);
                        }, event.target.type === 'file' ? 400 : 0)
                    }, false);
                });
            }
        });

        // Check again on submit
        const submit = form.querySelectorAll('form input[type=submit]')[0] || form.querySelectorAll('form button[type=submit]')[0];
        submit.addEventListener("click", e => {
            form.setAttribute("novalidate", true);
            const fields = form.querySelectorAll('.form-input__wrapper input:not([type=´submit´]), .form-input__wrapper select, .form-input__wrapper textarea');
            fields.forEach((field, index) => {
                validateFields(field);
            })
            if (!this.executed) {
                this.recaptchaWrapper.classList.add('g-recaptcha--error')
            }
            if(allErrors.length === 0) {
                this.valid = true;
            }
            this.onSubmit(e);
        })

        // Check file size of custom file upload field
        function validateFileSize(target) {
            let allUploadInputs = form.querySelectorAll('.form-input__wrapper-file input');
            let allSizeFields = form.querySelectorAll('.form-input__file-size');
            let errorText = form.querySelector('.form-input__error-text.file-upload');
            let errorField = errorText.closest('.form-input__wrapper');
            let allFilesSize = 0;

            let index = allErrors.indexOf(target.name);
            if (index !== -1) {
                allErrors.splice(index, 1);
            }

            for (let x = 0; x < allUploadInputs.length; x++) {
                if (allUploadInputs[x].files[0]) {
                    allFilesSize += allUploadInputs[x].files[0].size / 1024 / 1024;
                }
            }
            if (allFilesSize > 8) {
                errorText.innerHTML = errorText.getAttribute("data-text-size");
                errorField.classList.add('error');
                allSizeFields.forEach(function(el) {
                    el.classList.add('error');
                });
                allErrors.push(target.name);
            } else {
                errorField.classList.remove('error');
                allSizeFields.forEach(function(el) {
                    el.classList.remove('error');
                });
                allErrors = allErrors.filter(function(s) {
                    return s !== target.name;
                });
            }
        }

        function validateFields(target) {
            target.setCustomValidity(" ");

            let errorField = target.parentNode.closest('.form-input__wrapper');
            let errorText = errorField.querySelector('.form-input__error-text');

            if (target.validity.valueMissing) {
                errorText.innerHTML = errorText.getAttribute("data-text-mandatory");
                errorField.classList.add('error');
                allErrors.push(target.name);
            } else if (target.validity.tooShort) {
                errorText.innerHTML = errorText.getAttribute("data-text-short");
                errorField.classList.add('error');
                allErrors.push(target.name);
            } else if (target.validity.typeMismatch && (target.type === "email")) {
                errorText.innerHTML = errorText.getAttribute("data-text-pattern");
                errorField.classList.add('error');
                allErrors.push(target.name);
            } else if (target.type === "file" && target.name) {
                validateFileSize(target);
            } else {
                errorField.classList.remove('error');
                allErrors = allErrors.filter(a => a !== target.name);
            }
        }
    }
}
